import { DealFrom } from 'components/featured/Deals/components/DealForm';
import { DealType } from 'model/deals.model';
import { useLocation } from 'react-router-dom';

const DealNew = () => {
  const location = useLocation();
  let type = location.state.type;

  return (
    <div>
      <DealFrom pipelineType={type as DealType} isEdit={false} />
    </div>
  );
};

export default DealNew;
